







































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import PassengerImportMapper from '@/components/Importer/passenger/PassengerImportMapper.vue';
import { IEntity, IEntityImporter, IEntityMapping, IExcelRow } from '@/typings/import';
import Passenger from '../Passenger/models/Passenger';
import PassengerMapping from '@/components/Importer/models/passenger/PassengerMapping';
import PassengerImportsTable from '@/components/Importer/passenger/PassengerImportsTable.vue';
import { IPassengerImporterParams, PassengerImporter } from '@/components/Importer/models/passenger/PassengerImporter';
import PassengerSearchMapper from '@/components/Importer/passenger/PassengerSearchMapper.vue';
import PassengerSearchMapping from '@/components/Importer/models/passenger/PassengerSearchMapping';
import Destination from '../Passenger/models/Destination';
import IPassengerPhonNumberViewModel from '../Passenger/models/IPassengerPhoneNumberViewModel';
import PhoneNumberMapping from '@/components/Importer/models/phoneNumber/PhoneNumberMapping';
import PhoneNumbersMapper from '@/components/Importer/phoneNumber/PhoneNumbersMapper.vue';
import PhoneNumberImporter, { IPhoneNumberImporterParams } from './models/phoneNumber/PhoneNumberImporter';
import TransportationPermission from '../Passenger/models/TransportationPermission';
import TransportationPermissionMapping from './models/transportationPermission/TransportationPermissionMapping';
import TransportationPermissionsMapper from '@/components/Importer/transportationPermission/TransportationPermissionsMapper.vue';
import TransportationPermissionImporter, { ITransportationPermissionImporterParams } from './models/transportationPermission/TransportationPermissionImporter';
import { EEntityImportState } from './enums';
import ImportsTable from '@/components/Importer/ImportsTable.vue';

export interface IMappers {
  passenger: IEntityMapping<Passenger>;
  phoneNumbers: Array<IEntityMapping<IPassengerPhonNumberViewModel>>;
  search: IEntityMapping<Passenger>;
  transportationPermissions: Array<IEntityMapping<TransportationPermission>>;
}

@Component({
  components: {
    ImportsTable,
    PassengerImportMapper,
    PassengerImportsTable,
    PassengerSearchMapper,
    PhoneNumbersMapper,
    TransportationPermissionsMapper,
  },
})
export default class ImportSelectionStep extends Vue {
  mappings: IMappers = this.getOrInitializeMappings();

  passengerImporterSelected: boolean = true;
  ptpImporterSelected: boolean = false;
  scheduleImporterSelected: boolean = false;

  passengerImporter: IEntityImporter<Passenger> | null = null;
  phoneNumberImporters: Array<IEntityImporter<IPassengerPhonNumberViewModel>> = [];
  ptpImporters: Array<IEntityImporter<TransportationPermission>> = [];

  loading: boolean = false;
  loadingMessage: string = '';
  loadingProgress: number = 0;

  postedEntities: Array<IEntity<Passenger>> = [];
  failedEntities: Array<IEntity<Passenger>> = [];
  
  showImportsTable: boolean = false;

  selectPassengerImporter() {
    this.passengerImporterSelected = !this.passengerImporterSelected;
  }
  selectPtpImporter() {
    this.ptpImporterSelected = !this.ptpImporterSelected;
  }
  selectScheduleImporter() {
    this.scheduleImporterSelected = !this.scheduleImporterSelected;
  }

  onPassengerMappingChanged(mapping: IEntityMapping<Passenger>) {
    if (!this.mappings) {
      this.mappings = this.getOrInitializeMappings();
    }
    this.mappings.passenger = mapping;
    this.saveMappings();

    if (this.passengerImporter) {
      this.passengerImporter.onMappingChanged(mapping);
    }
  }

  onPassengerSearchMappingChanged(mapping: IEntityMapping<Passenger>) {
    this.mappings.search = mapping;
    Object.keys(this.mappings.search).forEach(k => {
      const copyUpdate = JSON.parse(JSON.stringify(this.mappings.search[k]));
      if (this.mappings.passenger) {
        this.mappings.passenger.updateSearchProperty(copyUpdate);
      }
      if (this.mappings.phoneNumbers) {
        this.mappings.phoneNumbers.forEach(pn => pn.updateSearchProperty(copyUpdate));
      }
      if (this.mappings.transportationPermissions) {
        this.mappings.transportationPermissions.forEach(ptp => ptp.updateSearchProperty(copyUpdate));
      }
    });
    this.saveMappings();
  }

  onPhoneNumberMappingsChanged(mappings: Array<IEntityMapping<IPassengerPhonNumberViewModel>>) {
    this.mappings.phoneNumbers = mappings;
    this.saveMappings();

    if (this.phoneNumberImporters.length > 0) {
      mappings.forEach((m, i) => {
        const importer = this.phoneNumberImporters[i];
        if (importer) {
          importer.onMappingChanged(m);
        }
      });
    }
  }

  onTransportationPermissionsMappingsChanged(mappings: Array<IEntityMapping<TransportationPermission>>) {
    this.mappings.transportationPermissions = mappings;
    this.saveMappings();

    if (this.ptpImporters.length > 0) {
      mappings.forEach((m, i) => {
        const importer = this.ptpImporters[i];
        if (importer) {
          importer.onMappingChanged(m);
        }
      });
    }
  }

  saveMappings() {
    localStorage.setItem('importer:mappings', JSON.stringify(this.mappings));
  }

  async fetchMatches() {
    try {
      this.loading = true;
      this.loadingMessage = this.$t('importer.fetchingPassengers');
      this.showImportsTable = false;

      const rowData = this.$store.state.importer.rowData;
      const excelRows: IExcelRow[] = rowData.map(rd => ({ excelRowData: rd }));
  
      const destinations = this.$store.state.destination.destinations as Destination[];
      const params: IPassengerImporterParams = { destinations };
      const importer = new PassengerImporter(excelRows, this.mappings.passenger);
      
      for (let i = 0; i < importer.data.length; i++) {
        this.loadingProgress = Math.ceil((i / importer.data.length) * 100);
        await importer.matchExisting(i, params);
      }

      importer.entities.sort((a, b) => a.excelRowIndex - b.excelRowIndex);

      this.passengerImporter = importer;

      if (this.passengerImporterSelected) {
        const phoneNumberImporters = this.mappings.phoneNumbers.map(pnm => {
          const phoneImporter = new PhoneNumberImporter(excelRows, pnm);
  
          phoneImporter.data.forEach((d, i) => {
            const passengerEntities = this.passengerImporter.entities.filter(e => e.excelRowIndex === i);
            const phoneParams: IPhoneNumberImporterParams =  { passengerEntities };
            phoneImporter.matchExisting(i, phoneParams);
          });
  
          return phoneImporter;
        });
  
        this.phoneNumberImporters = phoneNumberImporters;
      }
      
      if (this.ptpImporterSelected) {
        const ptpImporters = this.mappings.transportationPermissions.map(ptpm => {
          const ptpImporter = new TransportationPermissionImporter(excelRows, ptpm);
          return ptpImporter;
        });
        this.ptpImporters = ptpImporters;
  
        for (const [index, ptpImporter] of this.ptpImporters.entries()) {
          this.loadingMessage = this.$t('importer.fetchingTransportationPermission', { number: (index + 1)});
          for (let i = 0; i < ptpImporter.data.length; i++) {
              this.loadingProgress = Math.ceil((i / importer.data.length) * 100);
              const passengerEntities = this.passengerImporter.entities.filter(e => e.excelRowIndex === i);
              const ptpParams: ITransportationPermissionImporterParams = { passengerEntities };
              await ptpImporter.matchExisting(i, ptpParams);
          }
        }
      }
      
    } catch (error) {
      console.error(error);
    } finally {
      this.loading = false;
      this.showImportsTable = true;
    }
  }

  getOrInitializeMappings() {
    let mappings = this.mappings;

    if (mappings) {
      return this.mappings;
    }

    const storedMappings = localStorage.getItem('importer:mappings');
    if (storedMappings) {
      mappings = JSON.parse(storedMappings);
      mappings.passenger = new PassengerMapping(mappings.passenger);
      mappings.phoneNumbers = mappings.phoneNumbers.map(pn => new PhoneNumberMapping(pn));

      mappings.transportationPermissions = mappings.transportationPermissions
        .map(ptp => new TransportationPermissionMapping(ptp));

      mappings.search = new PassengerSearchMapping(mappings.search);

    } else {
      mappings = this.initializeMappings();
      this.saveMappings();
    }
    return mappings;
  }

  initializeMappings(): IMappers {
    return {
      passenger: new PassengerMapping(),
      phoneNumbers: [ new PhoneNumberMapping() ],
      transportationPermissions: [ new TransportationPermissionMapping() ],
      search: new PassengerSearchMapping(),
    };
  }

  clearMappings() {
    this.mappings = this.initializeMappings();
    this.saveMappings();
    this.clearImporters();
  }

  clearImporters() {
    this.passengerImporter = null;
    this.phoneNumberImporters = [];
    this.ptpImporters = [];
    this.showImportsTable = false;
  }

  async importPassengers() {
    if (!this.passengerImporter) {
      return;
    }
    
    this.loading = true;
    this.loadingProgress = 0;
    
    if (this.passengerImporterSelected) {
      this.loadingMessage = 'Tuodaan matkustajia';
      const selectedEntitites = this.passengerImporter.entities.filter(e => e.entity && e.selected);
      
      const destinations: Destination[] = this.$store.state.destination.destinations;
      const params: IPassengerImporterParams = { destinations };
  
      for (let i = 0; i < selectedEntitites.length; i++) {
        const entity = selectedEntitites[i];
        let phoneNumberEntities: Array<IEntity<IPassengerPhonNumberViewModel>> = [];
        try {
          
          if (this.phoneNumberImporters.length > 0) {
            phoneNumberEntities = await this.getPhoneNumbersForPassengerImport(entity);
          }
          entity.entity.phoneNumbers = entity.entity.phoneNumbers
            .concat(phoneNumberEntities.map(pne => pne.entity));
  
          const updatedEntity = await this.passengerImporter.postEntity(entity, params);
          
          if (updatedEntity === null) {
            entity.importState = EEntityImportState.Failed;
            phoneNumberEntities.forEach(pne => pne.importState = EEntityImportState.Failed);
          }
          
          entity.entity = updatedEntity;
          entity.importState = EEntityImportState.Imported;
          phoneNumberEntities.forEach(pne => pne.importState = EEntityImportState.Imported);
  
        } catch (error) {
          entity.importState = EEntityImportState.Failed;
          phoneNumberEntities.forEach(pne => pne.importState = EEntityImportState.Failed);
        }
        this.loadingProgress = Math.ceil((i / this.passengerImporter.entities.length) * 100);
      }
    }
    
    if (this.ptpImporterSelected && this.ptpImporters.length > 0) {
      this.loadingMessage = `Tuodaan kuljetuspäätösten tietoja`;
      this.loadingProgress = 0;

      const passengerEntities = this.passengerImporter.entities
      .filter(e => e.importState === EEntityImportState.Imported || (e.entity && e.entity.id));

      const passengerEntityRowIndexes = passengerEntities.map(pe => pe.excelRowIndex);
      const entityAmount = this.ptpImporters.flatMap(imp => imp.entities
        .filter(e => passengerEntityRowIndexes.includes(e.excelRowIndex)))
      .length;

      let progress = 0;

      for (const passengerEntity of passengerEntities) {
        for (const importer of this.ptpImporters) {
          const ptpEntities = importer.entities.filter(ptpe => ptpe.excelRowIndex === passengerEntity.excelRowIndex && ptpe.selected);
          for (const entity of ptpEntities) {
            try {
              const createdPtp = await importer.postEntity(entity, { passenger: passengerEntity.entity });
              if (createdPtp === null) {
                entity.importState = EEntityImportState.Failed;
              }

              entity.entity = createdPtp;
              entity.importState = EEntityImportState.Imported;
            } catch (error) {
              entity.importState = EEntityImportState.Failed;
            }
            progress++;
            this.loadingProgress = Math.ceil((progress / entityAmount) * 100);
          }
        }
      }
    }

    this.loading = false;
    this.loadingProgress = 0;
  }

  async getPhoneNumbersForPassengerImport(passengerEntity: IEntity<Passenger>) {
    const phoneNumbers: Array<IEntity<IPassengerPhonNumberViewModel>> = [];

    for (const importer of this.phoneNumberImporters) {
      const phoneNumberEntities = importer.entities.filter(e => e.excelRowIndex === passengerEntity.excelRowIndex);
      
      for (const pnEntity of phoneNumberEntities) {
        const phoneNumber = await importer.postEntity(pnEntity);
        pnEntity.entity = phoneNumber;

        if (phoneNumber) {
          phoneNumbers.push(pnEntity);
        }
      }
    }

    return phoneNumbers;
  }

}
